// extracted by mini-css-extract-plugin
export var dropdown = "_mc-1";
export var hidden = "_mc-0";